export const tr = {
    'clear-end-date-confirm-text': 'Bitiş tarihi sıfırlanacak, kampanya bakiyesi bitene kadar gösterim devam edecektir.'
};
